import React, { Component } from 'react';
import {
    Grid, Row, Col, Tabs, Tab, FormControl, FormGroup, ControlLabel, Form, Tooltip, OverlayTrigger, Table
} from 'react-bootstrap';
import Card from '../../components/Card/Card.jsx';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ProyectService from '../../services/ProyectService';
import ModalTarea from '../Incubation/IncubationPage/ModalTarea.jsx';

import Board from 'react-trello';
import moment from 'moment';

class Edit extends Component{
  constructor(props){
    super(props);
    this.state = {
      projectId: this.props.match.params.number,
      alert: null,
      key: 1,
      project: null,
      modal: {
        open: false,
        id: null,
      },
      kanban: null,
    };
    this.projectService = new ProyectService();
    this.handleSelect = this.handleSelect.bind(this);
    this.saveProject = this.saveProject.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.saveTask = this.saveTask.bind(this);
    this.loadProject = this.loadProject.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.deleteTask = this.deleteTask.bind(this);
  }

  componentWillMount() {
    this.loadProject(this.state.projectId);
  }

  loadProject(id) {
    //this.setState({gantt: null});

    this.setState({kanban: null, project: null});
    this.projectService.getProject(id)
    .then(resProject => {
      let planned = [];
      let inProgress = [];
      let completed = [];
      resProject.proyecto.tareas.forEach((card) => {
        let tags = [];
        let today = moment();
        let end = moment(card.fechafin, 'DD/MM/YYYY' );
        if(card.dependNombre){
          tags.push({title: `Depende de '${card.dependNombre}'`, color: 'white', bgcolor: '#F4A621'});
        }
        if(parseInt(card.porcentaje, 10) === 0 ){
          if(end.diff(today, 'days') < 0 ){
            tags.push({title: 'Atrasado', color: 'white', bgcolor: '#EB5A46'});
          }
          planned.push({id: card.id, title: card.nombre, description: `Inicio: ${card.fechainicio} - Fin: ${card.fechafin}` , label: ``, metadata: card, tags: tags});
        }
        if(parseInt(card.porcentaje, 10) === 100 ){
          completed.push({id: card.id, title: card.nombre, description: `Inicio: ${card.fechainicio} - Fin: ${card.fechafin}` , label: ``, metadata:card, tags: tags });
        }
        if(parseInt(card.porcentaje, 10) > 0 && parseInt(card.porcentaje, 10) < 100 ){
          if(end.diff(today, 'days') < 0 ){
            tags.push({title: 'Atrasado', color: 'white', bgcolor: '#EB5A46'});
          }
          inProgress.push({id: card.id, title: card.nombre, description: `Inicio: ${card.fechainicio} - Fin: ${card.fechafin} ` , label: `${card.porcentaje}%`, metadata:card, tags: tags});
        }
      });
      this.setState({kanban: {
        lanes: [
          {
            id: 'lane1',
            title: 'Planificado',
            label: `Total ${planned.length}`,
            cards: planned
          },
          {
            id: 'lane2',
            title: 'En progreso',
            label: `Total ${inProgress.length}`,
            cards: inProgress
          },
          {
            id: 'lane3',
            title: 'Completado',
            label: `Total ${completed.length}`,
            cards: completed
          }
        ]
      }, project: resProject.proyecto});
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ha ocurrido un error mientras se cargaba la información del proyecto, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>
      );
    });
  }

  generateTableContent() {
    const html = [];
    const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);
    const edit = (<Tooltip id="remove_tooltip">Editar</Tooltip>);
    let tareas = this.state.project.tareas;
    tareas.forEach((tarea) => {
      let today = moment();
      let end = moment(tarea.fechafin, 'DD/MM/YYYY' );
      let clase = '';
      if(end.diff(today, 'days') < 0 ){
        clase = "danger";
      }
      html.push(
        <tr key={tarea.id}>
            <td className="success">{tarea.nombre}</td>
            <td>{tarea.fechainicio}</td>
            <td className={clase}>{tarea.fechafin}</td>
            <td>{tarea.modified}</td>
            <td>{tarea.porcentaje}%</td>
            <td>
                <OverlayTrigger placement="top" overlay={edit}>
                  <Button
                    simple
                    onClick={() => this.setState({ modal: {open: true, id: tarea.id}, currentTask: tarea})}
                  >
                    <i className="fa fa-edit"></i>
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={remove}>
                  <Button simple onClick={() => this.confirmDelete(tarea.id, this.state.projectId)}>
                    <i className="fa fa-trash"></i>
                  </Button>
                </OverlayTrigger>
          </td>
        </tr>
      );
    });
    return html;
  }

  onChangeName(value) {
    const auxState = this.state.project;
    auxState.nombre = value;
    this.setState({ project: auxState, errorNombre: false });
  }

  onChangeDescription(value) {
    const auxState = this.state.project;
    auxState.descripcion = value;
    this.setState({ project: auxState, errorDesripcion: false });
  }

  saveProject() {
    let error = false;
    if (!this.state.project.nombre || this.state.project.nombre === '') {
      error = true;
      this.setState({errorNombre: true});
    }
    if (!this.state.project.descripcion || this.state.project.descripcion === '') {
      error = true;
      this.setState({errorDesripcion: true});
    }

    if (!error) {
      this.projectService
      .editProject(this.state.project)
      .then(res => {
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Listo!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              Proyecto actualizado exitosamente!
            </SweetAlert>
            )
          });
        })
        .catch(err => {
          this.errorAlert(
            <div>
              Ha ocurrido un error mientras se actualizaban los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>
          );
        });
    } else {
      this.errorAlert(
        <div>
          Uno o mas campos contienen errores o no han sido completados!
        </div>);
    }
  }

  confirmDelete(idTarea, idProyecto) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Borrar"
          onConfirm={() => this.deleteTask(idTarea, idProyecto)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí, bórrala!"
          cancelBtnText="Cancelar"
          showCancel
        >
          ¿Está seguro de borrar la tarea?
        </SweetAlert>
      )
    });
  }

  deleteTask(idTarea, idProyecto) {
    this.hideAlert();
    this.projectService.deleteTask(idTarea, idProyecto)
      .then(res => {
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Borrado!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              La tarea ha sido borrada satisfactoriamente
            </SweetAlert>
          )
        });
        this.loadProject(idProyecto);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se eliminaba la tarea, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  saveTask(tarea) {
    this.projectService.saveTask(tarea, this.state.project.id)
      .then(res => {
        this.setState({ modal: { open: false, id: null } });
        this.loadProject(this.state.projectId);
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Tarea guardada satisfactoriamente!</div>), 10);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información del proyecto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  handleSelect(key){
    this.setState({key});
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }

  render(){
    if (!this.state.project || !this.state.kanban) {
      return <div className="main-content"></div>
    }
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Editar Proyecto"
                content={
                  <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="incubacion-tabs">
                    <Tab eventKey={1} title="Info">
                      <Row>
                        <Col md={12}>
                          <Form>
                            <FormGroup validationState={this.state.errorNombre ? 'error': null}>
                              <ControlLabel>{'Nombre'}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.project.nombre}
                                onChange={(e) => this.onChangeName(e.target.value)}
                              />
                            </FormGroup>
                          </Form>
                        </Col>
                        <Col md={12}>
                          <Form>
                            <FormGroup validationState={this.state.errorDesripcion ? 'error': null}>
                              <ControlLabel>{'Descripcion'}</ControlLabel>
                              <FormControl
                                componentClass="textarea" type="text" style={{height: 120}}
                                value={this.state.project.descripcion}
                                onChange={(e) => this.onChangeDescription(e.target.value)}
                              />
                            </FormGroup>
                          </Form>
                        </Col>
                      </Row>
                      <div style={{ textAlign: "right", paddingBottom: 5}}>
                        <Button bsStyle="primary" fill wd onClick={this.saveProject}>
                          Guardar
                        </Button>
                      </div>
                    </Tab>
                    <Tab eventKey={2} title="Tareas">
                      <div style={{ textAlign: "right", paddingBottom: 5}}>
                        <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ modal: { open: true, id: null }})}>
                          Nueva Tarea
                        </Button>
                      </div>
                      <div style={{ with: 'auto',overflow: 'auto'}}>
                        <small className="text-danger">* se muestra ordenado por fecha de modificación de la tarea</small>
                        <Table striped bordered condensed hover>
                          <thead>
                            <tr>
                              <th>Tarea</th>
                              <th>Fecha Inicio</th>
                              <th>Fecha Fin</th>
                              <th>Modificación</th>
                              <th>% completo</th>
                              <th style={{width: '150px'}}>
                                Acciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.generateTableContent()}
                          </tbody>
                        </Table>
                        {this.state.project.tareas.length === 0 &&
                          <div style={{textAlign: 'center'}} >No hay tareas cargadas</div>
                        }
                      </div>
                    </Tab>
                    <Tab eventKey={3} title="Kanban">
                      {this.state.kanban ?
                        <Board data={this.state.kanban}
                              style={{backgroundColor: '#FFF'}}
                              onCardClick={(cardId, metadata, laneId) => this.setState({ modal: {open: true, id: metadata.id}, currentTask: metadata})}
                        />:
                        <div>No hay tareas cargadas!</div>
                      }

                    </Tab>
                  </Tabs>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.modal.open &&
          <ModalTarea
            tarea={this.state.modal.id ? this.state.currentTask : null}
            show={this.state.modal.open}
            closeModal={() => this.setState({ modal: {open: false, id: null}})}
            saveChanges={this.saveTask}
            projectId={this.state.project.id}
            proyectService={this.projectService}
            pushNotification={this.props.pushNotification}
            tareasExt={this.state.project.tareas}
          />
        }
      </div>
    );
  }
}
export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProjectManagement/Edit.jsx